export const aboutData = {
  name: "CyberIntel.uy",
  description: [
    "Registro de incidentes de ciberseguridad en Uruguay: ransomware, filtraciones y venta de datos anunciados por grupos de amenazas.",
  ],
  contactInfo: [
    {
      iconClassname: "fas fa-envelope icon",
      info: "Enviar un email",
      link: "mailto:saibergoust@proton.me",
    }
  ]
};

export const projectInfo = {
  developer: "Developed and maintained by Damián López Runco",
  disclaimer: "Sitio con fines informativos. La información proviene de fuentes públicas y de afirmaciones de los propios atacantes, que pueden estar o no verificadas; la mención de una organización no implica que haya confirmado el incidente. No alojamos ni compartimos datos filtrados, ni tenemos relación con los grupos mencionados. No constituye asesoramiento legal ni técnico."
};
